var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapinline = function SvgMapinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.79.333c-2.313 0-4.211 1.865-4.211 4.16a4.12 4.12 0 0 0 1.013 2.702l.003.004.003.003s1.645 1.857 2.282 2.456a1.336 1.336 0 0 0 1.819 0c.713-.671 2.284-2.458 2.284-2.458l.002-.002.002-.003A4.121 4.121 0 0 0 16 4.493c0-2.295-1.898-4.16-4.21-4.16Zm0 1.264c1.64 0 2.947 1.294 2.947 2.896 0 .718-.264 1.366-.703 1.873l-.001.002c-.007.007-1.644 1.848-2.2 2.37-.028.026-.058.026-.087 0v-.002c-.453-.424-2.195-2.364-2.2-2.371a2.841 2.841 0 0 1-.704-1.872c0-1.602 1.307-2.896 2.947-2.896Zm-6.537.412a.632.632 0 0 0-.43.179L.26 5.507a.631.631 0 0 0-.26.51v8.843a.632.632 0 0 0 1.003.51l4.26-3.097 4.26 3.098a.631.631 0 0 0 .743 0l4.632-3.369a.631.631 0 0 0 .26-.51V8.268c-.351.392-.837.926-1.263 1.375v1.526l-3.369 2.45v-3.124a75.098 75.098 0 0 1-1.263-1.307v4.43l-3.368-2.45V3.89l.843.613-.001-.009c0-.487.074-.957.205-1.403L5.71 2.194a.632.632 0 0 0-.456-.185ZM11.79 3.49a1.053 1.053 0 1 0 0 2.105 1.053 1.053 0 0 0 0-2.105Zm-7.158.398v7.28l-3.369 2.45V6.34l3.369-2.45Zm5.894 6.129c-.006-.005-.005.002 0 .015v-.015Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgMapinline;